import angular from 'angular';

angular
  .module('cloudX')
  .controller('EditAssignmentDialogCtrl', [
    '$http',
    'appUrls',
    'flySvc',
    '$element',
    'close',
    'invoiceStream',
    editAssignmentDialogCtrl,
  ]);

function editAssignmentDialogCtrl($http, appUrls, flySvc, $element, close, invoiceStream) {
  var vm = this;
  vm.saving = false;
  vm.invoiceStream = invoiceStream;
  vm.assignment = {
    assignmentId: invoiceStream.assignmentId,
    assignmentName: invoiceStream.assignmentName,
  };

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };

  vm.save = function() {
    if (vm.saving) return '';
    vm.saving = true;

    $http
      .put(appUrls.api + '/api/Assignment/Update', vm.assignment)
      .then(function({ data: invoiceStream }) {
        if (invoiceStream) {
          vm.invoiceStream = invoiceStream;
          close(invoiceStream, 500);
          $element.modal('hide');
        }
        vm.saving = false;
      })
      .catch(error => {
        showError(error);
      })
      .finally(() => {
        vm.saving = false;
      });
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
